import React, { ReactNode, useState } from 'react';

import ChevronRightIcon from '../../foundations/pictograms/chevron.svg';
import { classNames } from '../../utils/style';

export interface DisclosureProps {
  Header: ReactNode;
  Body: ReactNode;
}

export const Disclosure = ({ Header, Body }: DisclosureProps) => {
  const [open, setOpen] = useState(false);

  const toggle = (e: any) => {
    if (e.key === 'enter' || !e.key) {
      setOpen((prev) => !prev);
    }
  };

  return (
    <>
      <div
        className={classNames(
          'Disclosure',
          'w-full',
          'flex flex-row justify-between items-center'
        )}
        onClick={toggle}
        onKeyDown={toggle}
        tabIndex={0}
        role="button"
      >
        {Header}
        <div className="w-20">
          <ChevronRightIcon
            className={classNames(
              !open && 'transform rotate-180',
              'duration-200 transition fill-current',
              'text-blue-101 font-bold'
            )}
          />
        </div>
      </div>
      <div
        className={classNames(
          'mt-16',
          'transition-all max-h-0 opacity-0 duration-500 ease-in',
          open && 'max-h-auto opacity-100'
        )}
      >
        {Body}
      </div>
    </>
  );
};
